import {UseQueryResult} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

import {GET_SAMPLING_POINTS_PINNED_SECTION_KEY} from '../../api/queries/getSamplingPointsPinnedSection'

import {useSettingsQuery} from '@settings/modules/common/providers'

type DistributedCacheResponse = {keyIdentifier: string; value?: string}

export function useSamplingPointsPinnedSectionQuery(
  keyIdentifier: string
): UseQueryResult<DistributedCacheResponse> {
  const {t} = useTranslation()
  const isEnabled = keyIdentifier.length > 0

  return useSettingsQuery(GET_SAMPLING_POINTS_PINNED_SECTION_KEY, [keyIdentifier], {
    enabled: isEnabled,
    meta: {
      errorMessage: t('samplingPointsSettings.queries.fetchPinnedSamplingPointSectionError')
    }
  })
}
